import React from 'react';
import './Hero.css';

function Hero() {
    return (
        <section id="home" className="hero">
            <div className="hero-content">
                <h1 className="hero-heading">Coding Club</h1>
                <p className="hero-subheading">Helping students to code the future</p>
            </div>
        </section>
    );
}

export default Hero;